module.exports = __webpack_public_path__ + "img/group-1.7d0821a6.jpg";